import React from 'react'

const ApiError = ({ reload }: { reload: () => void }) => {
  return (
    <div className="flex justify-center align-center flex-col py-40px">
      <h3>Some thing went wrong. Reload the page and try again</h3>
      <button className="prim-btn mt-20px" onClick={reload}>
        Reload
      </button>
    </div>
  )
}

export default ApiError
